// Small helpers (no backend calls — this is a frontend-only app).

export function toPersianDigits(input) {
  if (input === null || input === undefined) return "";
  const str = String(input);
  const en = "0123456789";
  const fa = "۰۱۲۳۴۵۶۷۸۹";
  return str.replace(/[0-9]/g, (d) => fa[en.indexOf(d)]);
}

// Format Afghani currency (AFN) with Persian digits
export function formatAfn(n) {
  if (n === null || n === undefined || n === "") return "";
  const withCommas = Number(n).toLocaleString("en-US");
  return toPersianDigits(withCommas) + " افغانی";
}

// Backwards-compat alias used by some components
export function formatToman(n) {
  return formatAfn(n);
}

// Extract price from product (supports price_afn, price_toman, price)
export function getProductPrice(product) {
  if (!product) return null;
  return product.price_afn ?? product.price_toman ?? product.price ?? null;
}

export function buildWhatsAppLink(phoneNumber, text) {
  const clean = String(phoneNumber || "").replace(/[^0-9]/g, "");
  const encoded = encodeURIComponent(text || "");
  return `https://wa.me/${clean}?text=${encoded}`;
}

// Resolve image URL — supports both legacy string URLs and { url, thumb } objects
export function getImageUrl(img, variant = "url") {
  if (!img) return "";
  if (typeof img === "string") return img;
  if (variant === "thumb" && img.thumb) return img.thumb;
  return img.url || "";
}

// Parse a string into hashtags by splitting on any delimiter (space, comma, etc.)
// e.g. "#ali mohammad,hassan" => ["#ali", "#mohammad", "#hassan"]
export function parseHashtags(input) {
  if (!input) return [];
  return input
    .split(/[\s,;،؛|/\n]+/)
    .map((s) => s.trim())
    .filter(Boolean)
    .map((s) => (s.startsWith("#") ? s : "#" + s));
}

export function formatPersianDate(iso) {
  if (!iso) return "";
  try {
    return toPersianDigits(new Date(iso).toLocaleDateString("en-GB"));
  } catch {
    return "";
  }
}
